import PropTypes from "prop-types";
import { useCallback } from "react";
import { FormattedMessage } from "react-intl";
import { Form, useFormikContext } from "formik";
import Button, { BUTTON_SIZES, BUTTON_VARIANTS } from "app/pages/.shared/form/Button";
import InputFormik from "app/pages/.shared/form/InputFormik";
import Typography, { TYPOGRAPHY_VARIANTS } from "app/pages/.shared/Typography/Typography";
import { inputSanitize } from "app/utils/sanitize";
import "./PromotionCode.scss";

export const PROMOTION_STATE = {
	DEFAULT: "default",
	SUCCESS: "success",
	ERROR: "error",
};

const PromotionCode = ({
	promocodeState = PROMOTION_STATE.DEFAULT,
	submit = true,
	disableButton = false,
	disableField = false,
	onFocus = () => {},
	onClearInput = () => {},
	handleSubmit = () => {},
}) => {
	const { setFieldValue } = useFormikContext();

	// force the promo code to always be uppercase
	const handleInputChange = useCallback(
		event => {
			setFieldValue("promoCode", inputSanitize(event.target.value).toUpperCase());
		},
		[setFieldValue]
	);

	const handleInputFocus = useCallback(
		event => {
			if (typeof onFocus === "function") {
				onFocus(event);
			}

			// clear errors if promocode is not valid
			if (promocodeState === PROMOTION_STATE.ERROR) {
				onClearInput();
			}
		},
		[onFocus]
	);

	return (
		<Form className="promotion-code" data-testid="promotion-code">
			<div className="promotion-code__form">
				<div className="promotion-code__input">
					<InputFormik
						name="promoCode"
						id="promotion-code"
						type="text"
						label={<FormattedMessage id="promotion.code.label" />}
						data-testid="promocode-input"
						onFocus={handleInputFocus}
						onChange={handleInputChange}
						clearable={promocodeState === PROMOTION_STATE.SUCCESS}
						handleClearInput={onClearInput}
						disabled={disableField || promocodeState === PROMOTION_STATE.SUCCESS}
					/>
				</div>

				{
					<Button
						disabled={disableButton || promocodeState === PROMOTION_STATE.SUCCESS}
						variant={BUTTON_VARIANTS.FILLED}
						size={BUTTON_SIZES.LARGE}
						onClick={handleSubmit}
						submit={submit}
						className="promotion-code__button"
						data-testid="promocode-submit-button"
						label={<FormattedMessage id="promotion.code.submit.label" />}
					/>
				}
			</div>

			{disableField && (
				<Typography
					variant={TYPOGRAPHY_VARIANTS.REGULAR}
					isBold
					className="promotion-code__message"
				>
					<FormattedMessage id="promotion.code.disabled.credits" />
				</Typography>
			)}
		</Form>
	);
};

PromotionCode.propTypes = {
	handleSubmit: PropTypes.func,
	submit: PropTypes.bool,
	disableButton: PropTypes.bool,
	disableField: PropTypes.bool,
	onClearInput: PropTypes.func,
	onFocus: PropTypes.func,
	promocodeState: PropTypes.string,
};

export default PromotionCode;
